import { CARDANO_ADA_ASSET_ID } from "@sundae/cardano-utils";
export var ESupportedSpecialCurrencies;
(function (ESupportedSpecialCurrencies) {
    ESupportedSpecialCurrencies["ADA"] = "";
    ESupportedSpecialCurrencies["BTC"] = "BTC";
    ESupportedSpecialCurrencies["ETH"] = "ETH";
})(ESupportedSpecialCurrencies || (ESupportedSpecialCurrencies = {}));
export const SpecialCurrencyDecimals = {
    [CARDANO_ADA_ASSET_ID]: 6,
    [ESupportedSpecialCurrencies.BTC]: 8,
    [ESupportedSpecialCurrencies.ETH]: 18,
};
export const SpecialCurrencySymbols = {
    [CARDANO_ADA_ASSET_ID]: "₳",
    [ESupportedSpecialCurrencies.BTC]: "₿",
    [ESupportedSpecialCurrencies.ETH]: "Ξ",
};
export const getSpecialCurrencyDecimals = (currency, fallback) => {
    switch (currency) {
        case CARDANO_ADA_ASSET_ID:
            return SpecialCurrencyDecimals[CARDANO_ADA_ASSET_ID];
        case ESupportedSpecialCurrencies.BTC:
            return SpecialCurrencyDecimals[currency];
        case ESupportedSpecialCurrencies.ETH:
            return SpecialCurrencyDecimals[currency];
        default:
            return fallback ?? 2;
    }
};
export const getSpecialCurrencySymbol = (currency, fallback) => {
    switch (currency) {
        case CARDANO_ADA_ASSET_ID:
            return SpecialCurrencySymbols[CARDANO_ADA_ASSET_ID];
        case ESupportedSpecialCurrencies.BTC:
            return SpecialCurrencySymbols[currency];
        case ESupportedSpecialCurrencies.ETH:
            return SpecialCurrencySymbols[currency];
        default:
            return fallback ?? currency;
    }
};
//# sourceMappingURL=currency.js.map